export default {
  production: false,
  forceOfflineOnInit: false,
  databaseSpace: 'devDB'
}
